import React, { useState, useEffect } from 'react'
import { Cascader } from '@ow/comps'

const Render = function ({
  opts = {},
  onChange,
  value,
  onFetchRemoteData,
  style = {},
  filters,
}) {
  // remote 存在值时从remote获取级联数据
  const { slug, type, checkable = false } = opts

  console.log(slug, onChange, value)
  console.log('filter->>', value)
  const [orgs, setOrgs] = useState([])
  const [selectedObjectId, setSelectedObjectId] = useState(
    type === 'orgMultiple' ? [] : null
  )
  const handleSelectValues = (selectOptions) => {
    return type === 'orgMultiple'
      ? selectOptions.map((option) => option.id)
      : selectOptions.id
  }

  useEffect(() => {
    if (onFetchRemoteData) {
      const org = onFetchRemoteData('org')
      const arr = ((filters && filters.queries) || []).filter(
        (f) => f.type === 'orgMultiple'
      )

      const filterVal = arr && arr.length && arr[0].value
      org.fetchTreeData().then((data = []) => {
        const _data = data.map((item) => {
          console.log('filter->>', item, filterVal)
          return {
            ...item,
            disabled: filterVal && !!filterVal.includes(item.id),
          }
        })
        setOrgs(_data)
      })
    }
  }, [])

  useEffect(() => {
    console.log('filter->>', value)
    if (!value) setSelectedObjectId(type === 'orgMultiple' ? [] : null)
    else setSelectedObjectId(value)
  }, [value])

  return (
    <div className="w-full" style={{ height: '32px' }}>
      <Cascader
        tree={orgs || []}
        inputStyle={{
          height: '34px',
          width: '132px',
          ...style,
        }}
        placeholder={opts.hint || `请选择${opts.title}`}
        inputClassName="right-input"
        fieldNames={{
          label: 'title',
          value: 'id',
          children: 'children',
        }}
        checkable={checkable}
        multiple={type === 'orgMultiple'}
        onChange={(selectedKeys, selectedValues, a, b) => {
          console.log('filter->>', selectedKeys, selectedValues, a, b)
          if (selectedKeys) {
            setSelectedObjectId(handleSelectValues(b))
            onChange(selectedKeys)
          } else {
            setSelectedObjectId(null)
            onChange([])
          }
          // if (e && e.length > 0) {
          //   const { id } = e[0]
          //   onChange([id])
          // }
        }}
        value={selectedObjectId || undefined}
        notFoundContent="暂无数据"
      />
    </div>
  )
}

export default Render
